import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from "react-bootstrap";
import { apiCallAdmin } from "./services/api-service.js";
import gate_icon from "./assets/svg/Gate new logo-02 1.svg";
function PreLanding() {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();

  const redirectToLogin = () => {
    const currentURL = window.location.href;

    const redirectData = {
      redirectPath: currentURL,
      app: "gate",
      ts: Date.now(),
    };

    console.warn("🔐 Saving redirect in window.name:", redirectData);

    // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
    window.name = JSON.stringify(redirectData);
    document.cookie = "mawalog=; path=/; domain=.mawalog.com";
    window.location.href = `${accountsUrl}/login`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCallAdmin("GET", "get_role_permission/10", null, {
          params: {},
        });

        if (response.status === 200) {
          navigate('/dashboard');
          return;
        }

        if (response.status === 401) {
          redirectToLogin();
        }
      } catch (error) {
        console.error(error);
        redirectToLogin();
      }
    };

    fetchData();
  }, [navigate, accountsUrl]);

  return <Container fluid style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ffffff', paddingLeft: '0px', paddingRight: '0px' }}>
    <img src={gate_icon} alt="Gate Icon" width={'500px'} />

  </Container>;
}

export default PreLanding;
